var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71625 0 0 6.71625 0 15C0 23.2837 6.71625 30 15 30C23.2837 30 30 23.2837 30 15C30 6.71625 23.2837 0 15 0ZM16.7675 15C16.7675 15 20.6913 18.9237 20.8838 19.1162C21.3725 19.605 21.3725 20.3963 20.8838 20.8838C20.395 21.3725 19.6037 21.3725 19.1162 20.8838C18.9237 20.6925 15 16.7675 15 16.7675C15 16.7675 11.0762 20.6913 10.8837 20.8838C10.395 21.3725 9.60375 21.3725 9.11625 20.8838C8.6275 20.395 8.6275 19.6037 9.11625 19.1162C9.3075 18.9237 13.2325 15 13.2325 15C13.2325 15 9.30875 11.0762 9.11625 10.8837C8.6275 10.395 8.6275 9.60375 9.11625 9.11625C9.605 8.6275 10.3962 8.6275 10.8837 9.11625C11.0762 9.3075 15 13.2325 15 13.2325C15 13.2325 18.9237 9.30875 19.1162 9.11625C19.605 8.6275 20.3963 8.6275 20.8838 9.11625C21.3725 9.605 21.3725 10.3962 20.8838 10.8837C20.6925 11.0762 16.7675 15 16.7675 15Z",
    fill: "#EB3223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.30a74efcc63131700c78718d5baa426c.svg";
export { ForwardRef as ReactComponent };